export default "__VITE_ASSET__BqERGGnZ__"